export const environment = {
  production: false,
  frontUrl: 'https://dev.facturador.website/',
  apiUrl: 'https://api-dev.facturador.website/api',
};

/**

export const environment = {
  production: false,
  frontUrl: 'http://localhost:4200/',
  apiUrl: 'http://localhost:8090/api',
};

export const environment = {
  production: true,
  frontUrl: 'https://api.facturacion-idmhperu.website/',
  apiUrl: 'https://api.facturacion-idmhperu.website/api',
};

 */